import React, { useEffect, useState } from 'react';
import {withRouter} from 'react-router-dom';
import { Row, Col, Button, Label } from 'reactstrap';
import _ from 'lodash';
import moment from 'moment';
import { formatEmail, notify } from '../../../../utils';
import Select from 'react-select';

import useUnitRack from './useUnitRack';
import useUpdateValues from './useUpdateValues';
import TableLayoutter from './TableLayoutter';
import SpecialLocations from './SpecialLocations';
import Modal from './Modal';
import updateFunction from './updateFunction';
import apiClient from '../../../../apiClient';

const ManageRack = ({
    user, 
    stations,
    activeFirstTab
}) => {

    const units = (stations || []).map(s => s.s_unit);
    const unitSelectOptions = units.map(item => ({ label: item, value: item })).sort((a, b) => a.label.localeCompare(b.label));
    const [selectedUnit, setSelectedUnit] = useState('');
    const [selectedUnitOption, setSelectedUnitOption] = useState({ label: '', value: '' });
    const unitRack = useUnitRack(selectedUnit, user.s_email, activeFirstTab);
    const [schema, setSchema] = useState({});
    const [specialLocations, setSpecialLocations] = useState({});

    useEffect(() => {
        if (stations.length) {
            setSelectedUnit(stations[0].s_unit);
        }
    }, [stations]);

    useEffect(() => {
        if (unitRack && unitRack.schema) {
            const { schema, specialLocations={} } = unitRack;
            setSchema(schema);
            setSpecialLocations(specialLocations);
        }
    }, [unitRack]);

    const [modalOpen, setModalOpen] = useState(false);
    const { 
        value, 
        setValue,
        tower, 
        setTower,
        level,
        setLevel,
        location,
        setLocation,
        allowDuplicateLoc, 
        setAllowDuplicateLoc,
        tempControlled, 
        setTempControlled,
        tempSetting,
        setTempSetting,
        uuid,
        setUuid,
        action,
        type, 
        handleSetActionType,
        enableProcess
    } = useUpdateValues();

    const handleSelectOption = (option) => {
        setSelectedUnit(option.value);
        setSelectedUnitOption(option);
    };

    // const handleOperation = (action, type, tower='', level='', location='', allowDuplicates, specialLocation) => {
    //     const { tempControlled = null, uuid = null } = specialLocation || {};
    //     setTower(tower);
    //     setLevel(level);
    //     setLocation(location);
    //     setAllowDuplicateLoc('');
    //     if (action === 'UPDATE') {
    //         if (type === 'LOCATION') {
    //             setValue(location);
    //             setAllowDuplicateLoc(allowDuplicates);
    //         } else if (type === 'SPECIAL') {
    //             setValue(location);
    //             setTempControlled(tempControlled);
    //             setUuid(uuid);
    //         }
    //     } else {
    //         setValue('');
    //     }
    //     handleSetActionType(action, type);
    //     setModalOpen(true);
    // }

    const handleOperation = (action, type, tower='', level='', location='', settings) => {
        const {  allowDuplicates = null, tempSetting = null, uuid = null } = settings || {};
        setTower(tower);
        setLevel(level);
        setLocation(location);
        setAllowDuplicateLoc(allowDuplicates);
        setTempSetting(tempSetting);
        setUuid(uuid);
        setValue(location);
        // if (action === 'UPDATE') {
        //     if (type === 'LOCATION') {
        //         setValue(location);
        //         setAllowDuplicateLoc(allowDuplicates);
        //     } else if (type === 'SPECIAL') {
        //         setValue(location);
        //         setTempControlled(tempControlled);
        //         setUuid(uuid);
        //     }
        // } else {
        //     setValue('');
        // }
        handleSetActionType(action, type);
        setModalOpen(true);
    }

    const handleUpdate = async(override=null) => {
        const useAction = override || action;
        const useSchema = type === 'SPECIAL' ? specialLocations : schema;
        const { success, copy:updatedObj } = updateFunction(
            useSchema, useAction, type, value, tower, level, location, allowDuplicateLoc, tempSetting, uuid
        );

        if (success) {
            const data = {
                _id: unitRack._id,
                schema: updatedObj,
                modifiedBy: user.s_email
            }

            if (type === 'SPECIAL') {
                data.schema = schema;
                data.specialLocations = updatedObj;
            } else {
                data.schema = updatedObj;
                data.specialLocations = specialLocations;
            }
            
            const res = await apiClient.put('/updateUnitRack', { data });
            if (res.status === 200) {
                notify('Updated');
                const { schema, specialLocations } = res.data;
                setSchema(schema);
                setSpecialLocations(specialLocations);
                setModalOpen(false);
                setValue('');
            }
        } else {
            notify('Failed to update', 'warning');
        }
    }

    return (
        <>
            <Row className='px-3 py-1'>
                <Col md={3} className={'mb-1'}>
                    <Label>Select Unit:</Label>
                    <Select 
                        options={unitSelectOptions}
                        onChange={handleSelectOption}
                        value={selectedUnitOption}
                    />
                </Col>
                <Col md={12}>
                    <h4>
                        Manage Rack for {_.get(unitRack, 'unit', '')}
                        <span style={{ fontSize: '14px', marginLeft: '5px' }}>
                            (Last modified by {formatEmail(_.get(unitRack, 'modifiedBy', ''))} at {moment(_.get(unitRack, 'updatedAt', '')).format('MM/DD/YYYY HH:mm')})
                        </span>
                    </h4>
                </Col>
                <Col md={12}>
                    <Button
                        onClick={() => handleOperation('CREATE', 'TOWER')}
                    >
                        <i className="fas fa-plus-circle mr-2" />
                        Tower
                    </Button>
                </Col>
                <Col md={12} className={"mt-2"}>
                    {
                        Object.keys(schema).map((key, i) => (
                            <TableLayoutter 
                                tower={key}
                                levels={schema[key]}
                                handleOperation={handleOperation}
                                key={i}
                            />
                        ))
                    }
                </Col>
                <Col md={12} className={"mt-2"}>
                    <SpecialLocations 
                        specialLocations={specialLocations}
                        handleOperation={handleOperation}
                    />
                </Col>
            </Row>
            <Modal 
                modal={modalOpen}
                setModal={setModalOpen}
                value={value}
                setValue={setValue}
                allowDuplicateLoc={allowDuplicateLoc}
                setAllowDuplicateLoc={setAllowDuplicateLoc}
                action={action}
                type={type}
                tower={tower}
                level={level}
                handleUpdate={handleUpdate}
                enableProcess={enableProcess}
                tempControlled={tempControlled}
                setTempControlled={setTempControlled}
                tempSetting={tempSetting}
                setTempSetting={setTempSetting}
                uuid={uuid}
                setUuid={setUuid}
            />
        </>
    );
}

export default withRouter(ManageRack);
